import React from 'react';
import CommunityDropdown from '../Dropdown/CommunityDropdown';
import './Filter.scss';

const Filter = ({ 
  onSelect, 
  filterData, 
  title, 
  cls, 
  width,
  defaultSelection,
  alwaysShowDefaultSelection
}) => {

  return (
    <>
      <div className={`${cls} upcoming-event-filter`} style={{maxWidth : `${width ? width : '390'}px`}}>
        <label>{title}</label>

        <CommunityDropdown 
          data={filterData}
          onSelect={onSelect}
          width={width}
          defaultSelection={defaultSelection}
          alwaysShowDefaultSelection={alwaysShowDefaultSelection}
        />
        
      </div>
    </>
  )
}


export default Filter;
